import React from 'react'
import ReactDOM from 'react-dom'
import DashboardLayout from './components/DashboardLayout'

const coursenum = window.location.pathname.split('/')[3]

export let startApp = studentCount => {
  ReactDOM.render(
    <DashboardLayout coursenum={coursenum} studentCount={studentCount} />,
    document.getElementById('react-app')
  )
}
